import { LanguageCode } from '@/helpers/languageConstants'
import { ProcessedAuctionItem } from '@/types/domain/auction'
import { createContext } from 'react'

export interface LanguageContextType {
  currentLanguage: LanguageCode
  setLanguage: (language: LanguageCode) => void
  getLocalizedName: (item: ProcessedAuctionItem) => string
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined)